
(function() {
  var KLAVIYO_URL = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  var LIST_ID = "KFs7uG".replace(/\uFEFF/g, '').trim();
  var SOURCE = 'Postscript embedded form';
  var submitted = new Set();
  var emailCache = new Map();

  function findPostscriptForm(formId) {
    return document.querySelector('postscript-embedded-form[form-id="' + formId + '"]');
  }

  function isEmailInput(input) {
    if (!input || input.tagName !== 'INPUT') return false;
    var ariaLabel = input.getAttribute('aria-label') || '';
    return input.type === 'email' || /email/i.test(ariaLabel);
  }

  function extractEmail(formEl) {
    if (!formEl || !formEl.shadowRoot) return null;
    var inputs = formEl.shadowRoot.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      if (!isEmailInput(inputs[i])) continue;
      var value = (inputs[i].value || '').trim();
      if (value && $s.validateEmail(value)) return value;
    }
    return null;
  }

  function cacheEmail(formId) {
    var email = extractEmail(findPostscriptForm(formId));
    if (email) emailCache.set(formId, email);
  }

  function watchForm(formId) {
    var formEl = findPostscriptForm(formId);
    if (!formEl || !formEl.shadowRoot || formEl.dataset.klaviyoWatch === 'true') return;
    formEl.dataset.klaviyoWatch = 'true';
    formEl.shadowRoot.addEventListener('input', function(e) {
      if (!isEmailInput(e.target)) return;
      var value = (e.target.value || '').trim();
      if (value) emailCache.set(formId, value);
    }, true);
  }

  function submitToKlaviyo(email, formId, subscriberId) {
    var dedupeKey = formId + ':' + (subscriberId || email);
    if (submitted.has(dedupeKey)) return;
    submitted.add(dedupeKey);

    var data = new URLSearchParams();
    data.append('g', LIST_ID);
    data.append('email', email);
    data.append('$fields', 'source');
    data.append('source', SOURCE);

    $s.post({
      url: KLAVIYO_URL,
      data: data.toString(),
      error: function() {
        submitted.delete(dedupeKey);
      }
    });
  }

  window.addEventListener('postscript:embedded-form', function(ev) {
    var detail = ev.detail;
    if (!detail || !detail.formId) return;

    if (detail.type === 'mount') {
      watchForm(detail.formId);
      return;
    }

    if (detail.type === 'step-change') {
      cacheEmail(detail.formId);
      return;
    }

    if (detail.type !== 'complete') return;

    var formId = detail.formId;
    var email = emailCache.get(formId) || extractEmail(findPostscriptForm(formId));
    if (!email || !$s.validateEmail(email)) return;

    submitToKlaviyo(email, formId, detail.subscriberId);
  });

  document.querySelectorAll('postscript-embedded-form[form-id]').forEach(function(formEl) {
    watchForm(formEl.getAttribute('form-id'));
  });
})();

